export const searchMixin = {
	data() {
		return {
			search: {
				assign_mode: 0,
				date_mode: 1,
				statusses: '', 
				start_date: '',
				end_date: '',
				group_mode: 0
			}			
		}
	},
	methods: {
		reset_search() {
			this.search.assign_mode = 0;
			this.search.date_mode = 1;
			this.search.statusses = '';
			this.search.start_date = '';
			this.search.end_date = '';
			this.search.group_mode = 0;
		},		
		parse_search(search_json) {
			this.reset_search();

			let parsed_search = JSON.parse(search_json);

			if (parsed_search.hasOwnProperty('assign_mode')) { this.search.assign_mode = parsed_search.assign_mode };
			if (parsed_search.hasOwnProperty('date_mode')) { this.search.date_mode = parsed_search.date_mode };
			if (parsed_search.hasOwnProperty('statusses')) { this.search.statusses = parsed_search.statusses };
			if (parsed_search.hasOwnProperty('start_date')) { this.search.start_date = parsed_search.start_date };
			if (parsed_search.hasOwnProperty('end_date')) { this.search.end_date = parsed_search.end_date };
			if (parsed_search.hasOwnProperty('group_mode')) { this.search.group_mode = parsed_search.group_mode };
		},	
	}
}